import { styled } from '@mui/material'
import { memo, ReactNode, useState } from 'react'

const Wrap = styled('div')`
  position: relative;
  width: auto;
  overflow: visible;
`
const Trigger = styled('div')`
  cursor: default;
`
const Popup = styled('div')`
  position: absolute;
  bottom: 100%;
  left: 0;
  background: ${({ theme }) => theme.color.bgLightGray};
`
export const DevToolsPopup = memo<{ children: ReactNode; popup: ReactNode }>(
  ({ children, popup }) => {
    const [visible, setVisible] = useState(false)
    return (
      <Wrap
        onMouseOver={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        <Trigger>{children}</Trigger>
        {visible && <Popup>{popup}</Popup>}
      </Wrap>
    )
  },
)
